
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionDispInfo } from "../../../../../domain/workflow";
import { ReceptionCommentKinds, } from "../../../../../domain/workflow/kinds";

@Component
export default class CommentDisplayMixin extends Mixins() {
  @Prop()
  labelSetting: ReceptionDispInfo;

  get conflictCommentTitle(): string {
    return "競合コメント";
  }

  getCommentLabel(kind: ReceptionCommentKinds): string {
    const dispSetting = this.labelSetting ? this.labelSetting : new ReceptionDispInfo();

    switch (kind) {
      case ReceptionCommentKinds.Comment:
        return dispSetting.commentLabelName;
      case ReceptionCommentKinds.Restrict:
        return dispSetting.restrictCommentLabelName;
      case ReceptionCommentKinds.NextMessage:
        return dispSetting.nextMessageLabelName;
      case ReceptionCommentKinds.BackMessage:
        return dispSetting.backMessageLabelName;
      case ReceptionCommentKinds.ContactedInfo:
        return dispSetting.contactedCommentLabelName;
      case ReceptionCommentKinds.Delete:
        return dispSetting.delCommentLabelName;
      case ReceptionCommentKinds.Conflict:
        return this.conflictCommentTitle;
      default:
        return "コメント";
    }
  }
}
